import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/user/auth.service';
import { LoadingController, NavController, ModalController, AlertController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmacaoPage } from '../confirmacao/confirmacao.page'
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  // tslint:disable-next-line: import-spacing
} from "@angular/common/http";
import { trigger, style, animate, transition } from '@angular/animations';
@Component({
  selector: 'app-novo-usuario',
  templateUrl: './novo-usuario.page.html',
  styleUrls: ['./novo-usuario.page.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(900, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class NovoUsuarioPage implements OnInit {

  authState: boolean = false;
  idAtual: any; // id do usuario atualmente logado

  btVinculo = [];
  vinculoFinal: any = "";
  vinculoChecked = false
  public registerForm: FormGroup;
  public loading: any;
  paramsObj: any;

  constructor(
    private authService: AuthService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private fb: FormBuilder,
    public navCtrl: NavController,
    public modalController: ModalController,
    public alertController: AlertController,
    private router: Router,
    private http: HttpClient
  ) {

    this.btVinculo = [
      //{ cor: "secondary", checked: false, texto: "Membro" }, 
      //{ cor: "secondary", checked: false, texto: "Servidor" },
      { cod: "estagiario", cor: "secondary", checked: false, texto: "Estagiário sem e-mail funcional" },
      { cod: "terceirizado", cor: "secondary", checked: false, texto: "Terceirizado (e-mail pessoal ou .terc@mprj.mp.br)" }]

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    this.registerForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: ['', Validators.compose([Validators.minLength(6), Validators.required])],
      telefone: [''],
      profileName: [''],
    });



  }

  ngOnInit() { //pega os dados do usuário atualmente logado e define o idAtual - esses dados vem do sistema de autenticação do firebase e não do banco de dados.
    /*  this.afAuth.authState.subscribe(auth => {
         if (auth) {
             this.authState = true;
             this.idAtual = auth.uid
           //  this.navCtrl.navigateRoot('/perfil-usuario/' + this.idAtual);
             if (this.idAtual == this.itemId) {
                 this.ePropietario = true;
             }
         } else {
             this.authState = false;
             this.ePropietario = false;
         }
     }); */
    //-------------------------------------------------------------
  }

  alteraVinculo(vinculo, i) {
    if (this.btVinculo[i]['checked'] === false) {
      this.btVinculo[i]['checked'] = true
      this.btVinculo[i]['cor'] = 'vermelho'
    } else {
      this.btVinculo[i]['checked'] = false
      this.btVinculo[i]['cor'] = 'secondary'
    }
    this.btVinculo.forEach((info2) => {
      if (info2.checked = true) {
        info2.checked = false
        info2.cor = 'secondary'
        this.btVinculo[i]['checked'] = true
        this.btVinculo[i]['cor'] = 'vermelho'
      }
    })
    this.vinculoFinal = vinculo
    this.vinculoChecked = true;
  }


  //------------apresenta o alerta de SEM NOME--------------------------------------------------------------------------------------
  async alertaOutros(mensagem) {
    const alert = await this.alertController.create({
      animated: true,
      backdropDismiss: false,
      header: 'Campo obrigatório!',
      message: mensagem,
      buttons: [
        {
          cssClass: 'primary',
          role: 'cancel',
          text: 'Entendi',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
    return
  }
  //------------ FIM apresenta o alerta de SEM NOME--------------------------------------------------------------------------------------


  async chamaAlerta(message, buttons) {
    const alert = await this.alertCtrl.create({
      message,
      buttons
    });
    await alert.present();
  }

  async modalConfirmacao(usuario) {
    // console.log(usuario)
    const modal = await this.modalController.create({
      component: ConfirmacaoPage,
      componentProps: { usuario },
      backdropDismiss: true,
      animated: false,
      mode: 'ios'

    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    // console.log("data", data);
    if (!data || data.length == 0 || data == 'fechar') {
      // console.log("nada!")
    } else {
      if (data.acao === 'confirmado') {
        // console.log("novo-usuario.page", usuario)
        this.emailUserLogin(data.usuario);
      }
    }
  }


  async cadastraUsuario(registerForm: FormGroup) {




    if (!registerForm.valid) {

    } else {
      let nomeFinal = null
      nomeFinal = this.registerForm.value["profileName"]
      if (nomeFinal === "") {
        let mensagem = "Você deve preencher seu nome para finalizar o cadastro"
        this.alertaOutros(mensagem)
        return
      }

      function hashCode(str) {
        var hash = 0;
        if (str.length == 0) return hash;
        for (let i = 0; i < str.length; i++) {
          let char = str.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
      }




      var splitstring = this.registerForm.value.email.split('@')
      var username = splitstring[0]
      let userObj = {
        "email": this.registerForm.value.email,
        "enabled": true,
        "loggedIn": true,
        "nmCompleto": this.registerForm.value["profileName"],
        "password": this.registerForm.value["password"],
        "telefone": this.registerForm.value["telefone"],
        "username": "username",
        "vinculo": this.vinculoFinal["cod"],
        "userLdap": false,
        "cdmatricula": 'fake_' + hashCode(this.registerForm.value.email)
      }

      // console.log("userObj", userObj)
      this.loading = await this.loadingCtrl.create();
      this.loading.present();
      registerForm.reset();
      this.authService.cadastrarUsuario(userObj)
        .subscribe((event: HttpEvent<any>) => {
          // console.log(event)

          switch (event.type) {
            case HttpEventType.Sent:
              // console.log(HttpEventType.Sent)
              break;
            case HttpEventType.ResponseHeader:
              if (event.status == 200) {

                this.loading.dismiss().then(() => {
                  //   let message = "Cadastro realizado com sucesso"
                  //   let buttons = [{ text: 'Ok', role: 'cancel' }]
                  //   this.chamaAlerta(message, buttons)

                  this.modalConfirmacao(userObj)

                });
              }
              if (event.status == 400) {
                this.loading.dismiss().then(() => {
                  let message = "Este e-mail já está em nosso cadastro.  Você será redirecionado(a) a página de login."
                  let buttons = [{ text: 'Ok', role: 'cancel' }]
                  this.chamaAlerta(message, buttons)
                  this.router.navigateByUrl('/login/terceiros');
                  // this.router.navigateByUrl('/reset-password');
                });
              }
              break;
            case HttpEventType.Response:

              break;
          }
        },
          (error) => {
            //Handle the error here
            //If not handled, then throw it
            // console.log(error)
            throw error;
          });

    }
  }


  async emailUserLogin(usuario) {
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    let userObj = {
      email: usuario.email,
      password: usuario.password
    }


    // userObj['username'] = this.emailForm.value.email;  // comentar depois ###########################
    // console.log("userObj", userObj)

    this.authService.loginUsuario(userObj).subscribe(
      res => {
        // console.log('HTTP response', res)
        if (res['cod'] == 200) {

          localStorage.setItem("cvusr", JSON.stringify("database"));
          this.loading.dismiss().then(() => {
            // this.authService.getUserData('')
            window.location.reload()
            // this.router.navigateByUrl('/novo-saude');
          });
        }

      },
      err => {
        // console.log('HTTP Error', err)
        if (err.error.cod == 401) {
          let message
          if (err.error.status === "ERRO AO EFETUAR LOGIN: SENHA INVALIDA") {
            message = "Não foi possível realizar o login.  Por favor, verifique a senha utilizada."
          } else {
            message = "Usuário não cadastrado.  Por favor, verifique os dados ou faça seu cadastro."
          }
          this.loading.dismiss().then(() => {

            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
            return
            // this.router.navigateByUrl('/login');
          });
        }
        if (err.error.cod == 403) {
          this.loading.dismiss().then(() => {
            let message = "É necessária a confirmação do e-mail cadastrado. Verifique seu e-mail e tente realizar o login novamente."
            let buttons = [{ text: 'Ok', handler: (d) => this.modalConfirmacao(userObj) }]
            this.chamaAlerta(message, buttons)

            this.router.navigateByUrl('/login');
          });
        }
      },
      () => this.loading.dismiss()
    );


  }


}


